module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"addQuestion":"Frage hinzufügen","answers":"{count} Antworten","noQuestionsAvailable":"Keine Fragen vorhanden","questions":"Fragen"},"en":{"addQuestion":"Add question","answers":"{count} Antworten","noQuestionsAvailable":"No questions available","questions":"Questions"}}')
  delete Component.options._Ctor
}
